import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';
import { cn } from '@root/src/utils/cn';

interface GuestLegalBarProps {
  className?: string;
}

/**
 * Legal bar for unauthenticated visitors on the job-list homepage.
 *
 * Rendered under the mission chips (no footer on the job-list homepage) so its
 * Terms & Privacy links are present in the initial server HTML — required for
 * crawlers and Google's OAuth homepage check, which never log in and never open
 * menus. Transparent background.
 */
export const GuestLegalBar = ({ className }: GuestLegalBarProps) => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <div
      className={cn(
        'flex w-full flex-row items-center justify-between gap-3 pb-0 pt-2 text-left',
        className,
      )}
    >
      <span className="whitespace-nowrap text-[10px] uppercase text-ink md:text-xs">
        {`© ${currentYear} BESTJOBS RECRUTARE SA`}
      </span>
      <div className="flex items-center gap-4">
        <LinkStyled href="/legal/terms" size="xs" styling="text" color="ink" className="whitespace-nowrap md:text-sm">
          {t('menu.conditions')}
        </LinkStyled>
        <LinkStyled href="/legal/confidentiality" size="xs" styling="text" color="ink" className="whitespace-nowrap md:text-sm">
          {t('menu.confidentiality')}
        </LinkStyled>
      </div>
    </div>
  );
};
